import { Fragment, useState, useEffect } from 'react'
import callApi from '../../helpers/callapi'
import { useDispatch } from 'react-redux'
import config from '../../config'
import Paginations from '../../components/Nav/Pagination'
import DateRangePicker from 'react-bootstrap-daterangepicker'
import 'bootstrap-daterangepicker/daterangepicker.css'
import { format } from 'date-fns'

import { Card, Button, Row, Col, Table, Modal, Tab, Nav } from 'react-bootstrap'

const PayOutMhee = () => {
  const [status, setStatus] = useState('pending')
  const [payOuts, setPayOuts] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [round, setRound] = useState('')
  const [showModalApprove, setshowModalApprove] = useState(false)
  const [showModalCanceled, setshowModalCanceled] = useState(false)
  const [startEndDate, setStartEndDate] = useState({
    startDate: null,
    endDate: null,
  })

  const dispatch = useDispatch()

  const fetchpayOuts = async (page) => {
    try {
      dispatch({ type: 'loading_show' })
      const query = {
        status: status,
        round: round,
        page: page || 1,
        ...(startEndDate.startDate && {
          startDate: format(new Date(startEndDate.startDate), 'yyyy-MM-dd'),
        }),
        ...(startEndDate.endDate && {
          endDate: format(new Date(startEndDate.endDate), 'yyyy-MM-dd'),
        }),
      }
      const result = await callApi({
        fullURL: `${config.urlHost}/payOuts`,
        query,
      })
      const data = result.data.map((payout) => Object.assign(payout, { checked: false }))
      setPayOuts(data)
      dispatch({ type: 'loading_hide' })
    } catch (error) {
      alert('error')
      console.log('error', error)
      dispatch({ type: 'loading_hide' })
    }
  }

  const approvePayouts = async () => {
    const payOutId = payOuts.filter((payout) => payout.checked).map((payout) => payout.id)
    try {
      dispatch({ type: 'loading_show' })
      await callApi({
        fullURL: `${config.urlHost}/payOuts/pay`,
        method: 'post',
        body: { payOutId },
      })
      fetchpayOuts()
      reset()
      dispatch({ type: 'loading_hide' })
    } catch (error) {
      alert('error')
      reset()
      console.log('error', error)
      dispatch({ type: 'loading_hide' })
    }
  }

  const cancelPayOuts = async () => {
    const payOutId = payOuts.filter((payout) => payout.checked).map((payout) => payout.id)
    try {
      dispatch({ type: 'loading_show' })
      await callApi({
        fullURL: `${config.urlHost}/payOuts/cancel`,
        method: 'put',
        body: { payOutId },
      })
      fetchpayOuts()
      reset()
      dispatch({ type: 'loading_hide' })
    } catch (error) {
      alert('error')
      reset()
      console.log('error', error)
      dispatch({ type: 'loading_hide' })
    }
  }

  useEffect(() => {
    fetchpayOuts()
    setCurrentPage(1)
  }, [status, round, startEndDate])

  const onChangePage = (page) => {
    setCurrentPage(page)
    fetchpayOuts(page)
  }
  const handleOnChangeChecked = (e) => {
    const id = e.target.value
    const data = payOuts.map((payout) =>
      Object.assign(payout, {
        checked: payout.id === id ? !payout.checked : payout.checked,
      }),
    )
    setPayOuts(data)
  }

  const handleCheckeds = (e) => {
    const data = payOuts.map((payout) => Object.assign(payout, { checked: e.target.checked }))
    setPayOuts(data)
  }

  const reset = () => {
    const el = document.querySelector('#selectAll')
    el.checked = false
  }

  const handleOnChange = (e, picker) => {
    if (e.type === 'apply') {
      setStartEndDate({
        startDate: picker.startDate._d,
        endDate: picker.endDate._d,
      })
    }
  }

  return (
    <Fragment>
      <Card>
        <Card.Header>
          <Card.Title>Payout</Card.Title>
        </Card.Header>
        <Card.Body>
          <Row className="d-flex justify-content-start align-items-center mb-4">
            <b className="ml-3">สถานะ : </b>
            <Col>
              <Tab.Container defaultActiveKey="pending">
                <Nav as="ul" className="nav-pills light">
                  <Nav.Item
                    as="li"
                    onClick={() => {
                      setStatus('pending')
                    }}
                  >
                    <Nav.Link eventKey="pending">รอโอนเงิน</Nav.Link>
                  </Nav.Item>
                  <Nav.Item
                    as="li"
                    onClick={() => {
                      setStatus('paid')
                    }}
                  >
                    <Nav.Link eventKey="paid">โอนเงินแล้ว</Nav.Link>
                  </Nav.Item>
                  <Nav.Item
                    as="li"
                    onClick={() => {
                      setStatus('canceled')
                    }}
                  >
                    <Nav.Link eventKey="canceled">ยกเลิกการโอนเงิน</Nav.Link>
                  </Nav.Item>
                  <Nav.Item
                    as="li"
                    onClick={() => {
                      setStatus('error')
                    }}
                  >
                    <Nav.Link eventKey="error">เกิดข้อผิดพลาด</Nav.Link>
                  </Nav.Item>
                </Nav>
              </Tab.Container>
            </Col>
          </Row>
          <Row className="d-flex justify-content-start align-items-center mb-4">
            <b className="ml-3">รอบเวลา : </b>
            <Col lg={4} md={6} sm={8}>
              <select
                className="form-control"
                style={{ color: '#5d5d5d' }}
                onChange={(value) => {
                  setRound(value.target.value)
                }}
              >
                <option value="">ทั้งหมด</option>
                <option value="round1">รอบเช้า</option>
                <option value="round2">รอบบ่าย</option>
                <option value="urgent">รอบด่วน</option>
              </select>
            </Col>
            <b className="ml-3">วันที่ : </b>
            <Col lg={3} md={4} sm={5}>
              <DateRangePicker onEvent={handleOnChange} start>
                <Button variant="outline-info">
                  {startEndDate.startDate && startEndDate.endDate
                    ? `${new Date(startEndDate.startDate).toLocaleDateString('TH-th')} ถึง ${new Date(
                        startEndDate.endDate,
                      ).toLocaleDateString('TH-th')}`
                    : 'เลือกวันที่'}
                </Button>
              </DateRangePicker>
            </Col>
          </Row>
          {status && status === 'pending' && (
            <Row className="align-items-right mb-4">
              <Col>
                <Button variant="success light" onClick={() => setshowModalApprove(true)}>
                  Approve
                </Button>

                <Button variant="danger light" onClick={() => setshowModalCanceled(true)}>
                  Canceled
                </Button>
              </Col>
            </Row>
          )}
          <Table responsive striped bordered className="verticle-middle">
            <thead>
              <tr>
                {status && status === 'pending' && (
                  <th>
                    <input type="checkbox" name="selectAll" id="selectAll" onClick={handleCheckeds} /> Select All
                  </th>
                )}
                <th>วันที่/เวลา</th>
                <th>ชื่อ</th>
                <th>ธนาคาร</th>
                <th>เลขบัญชี</th>
                <th>จำนวนเงิน</th>
                <th>สถานะ</th>
                <th>note</th>
                {status && status === 'error' && <th>รายละเอียด</th>}
              </tr>
            </thead>
            <tbody>
              {payOuts &&
                payOuts.map((data, i) => {
                  return (
                    <tr key={i}>
                      {status && status === 'pending' && (
                        <td>
                          <input
                            type="checkbox"
                            id={data.id}
                            value={data.id}
                            checked={data.checked}
                            onChange={handleOnChangeChecked}
                          />
                        </td>
                      )}
                      <td>{new Date(data.createdAt).toLocaleString('TH-th')}</td>
                      <td>{data.accountName}</td>
                      <td>{data.bankName}</td>
                      <td>{data.accountNumber}</td>
                      <td>{(Number.parseFloat(data.amount) / 100).toFixed(2)}</td>
                      <td>{data.status}</td>
                      <td>{data.note}</td>
                      {status === 'error' && <td>{data.transFerStatus}</td>}
                    </tr>
                  )
                })}
            </tbody>
          </Table>
          <Paginations currentPage={currentPage} onChangePage={onChangePage} items={payOuts} perPage={20} />
        </Card.Body>

        <Modal show={showModalApprove} centered>
          <Modal.Body>
            ยืนยันการโอนเงิน ?
            <Button variant="" className="close" onClick={() => setshowModalApprove(false)}>
              <span>&times;</span>
            </Button>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="danger light" onClick={() => setshowModalApprove(false)}>
              ยกเลิก
            </Button>
            <Button
              variant="primary light"
              onClick={() => {
                approvePayouts()
                setshowModalApprove(false)
              }}
            >
              ยืนยัน
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showModalCanceled} centered>
          <Modal.Body>
            ยกเลิกการโอนเงิน ?
            <Button variant="" className="close" onClick={() => setshowModalCanceled(false)}>
              <span>&times;</span>
            </Button>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="danger light" onClick={() => setshowModalCanceled(false)}>
              ยกเลิก
            </Button>
            <Button
              variant="primary light"
              onClick={() => {
                cancelPayOuts()
                setshowModalCanceled(false)
              }}
            >
              ยืนยัน
            </Button>
          </Modal.Footer>
        </Modal>
      </Card>
    </Fragment>
  )
}
export default PayOutMhee
